<template>
	<el-dialog class='dialog-statistics' :title="title" :visible.sync="dialogVisible" width="50%">
		<el-form ref="form" :model="formData" label-width="100px" :rules="rules">
			<el-form-item label="联系电话" prop="mobile">
				<el-input type="textarea" v-model="formData.mobile" placeholder="">
				</el-input>
			</el-form-item>

			<el-form-item label="申诉描述" prop="description" :rules="[{required: true, message: '请输入申诉描述'}]">
				<el-input type="textarea" v-model="formData.description" placeholder="">
				</el-input>
			</el-form-item>

			<el-form-item label="附件" prop="file" :rules="[{required: true}]">
				<el-upload class="upload-demo" multiple :limit="9" :action="action" :on-preview="handlePreview" :before-upload="beforeUpload" :on-success="onSuccess"
					:on-error="onError" :on-remove="handleRemove" :file-list="fileList" list-type="picture">
					<el-button size="mini" type="primary">上传附件</el-button>
					<!-- <div slot="tip" class="el-upload__tip">支持jpg、png格式、大小不超过5MB</div> -->
				</el-upload>

			</el-form-item>

		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" @click="confirmHandle">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { creditObjectionAppeals } from '@/api';
import BASE_URL from '@/api/base.js'

export default {
	components: {},
	data() {
		return {
			action: BASE_URL + '/api/file/upload',
			dialogVisible: false,
			rules: {
				description: [{ required: true, message: '请输入申诉描述' },],
			},
			parentParam: {},
			formData: {
				file: []
			},
			fileList: []
		};
	},
	methods: {

		show(v) {
			this.$set(this, 'dialogVisible', true)
			this.$set(this, 'parentParam', v || {});
		},
		handleRemove(file, fileList) {
			this.$set(this.formData, 'file', this.formData.file.filter(item => item.name !== file.name));
		},
		handlePreview(file) {
			console.log(file);
		},
		beforeUpload(file) {

		},
		onSuccess(response, file, fileList) {
			const { name } = file;
			const { result } = response;
			this.$set(this.formData, 'file', [...this.formData.file || [], {
				url: result,
				name
			}]);
		},
		onError() { },
		close() {
			this.$refs['form'].resetFields();
			this.$set(this, 'formData', {});
			this.dialogVisible = false;
		},
		confirmHandle() {
			const { name, number, id, type } = this.parentParam;
			const { mobile, description, file = [] } = this.formData;
			const params = {
				appealtype: this.appealtype,
				name,
				number,
				mobile,
				dataid: id,
				description,
				type: type.includes('法人') ? '法人' : '自然人',
				file
			}
			creditObjectionAppeals(params).then(res => {
				this.$message({
					message: '提交成功',
					type: 'success'
				});
				this.close();
			})
		}
	},
	computed: {
		title() {
			const { name, tabId } = this.parentParam;
			return `${name}-${tabId}-异议申诉`
		},
		appealtype({ parentParam }) {
			const { tabId } = parentParam;
			switch (+tabId) {
				case '信息概览':
					return 0;
				case '行政许可':
					return 1;
				case '行政处罚':
					return 2;
				case '守信红名单':
					return 3;
				case '失信黑名单':
					return 4;
				case '企业经营异常名录':
					return 5;
				default:
					return 0;
			}
		}
	},
	watch: {},
}
</script>
<style lang='scss' >
	.dialog-statistics {
	

        .upload-demo{
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
        }
	}
</style>